import {
  MuiAccordion,
  MuiAccordionDetails,
  MuiAccordionSummary,
  MuiTypography,
} from '@/features/shared/material-ui';
import { Theme } from '@/utils/constants';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import clsx from 'clsx';
import React, { ChangeEvent, memo, PropsWithChildren, useEffect, useState } from 'react';
import useStyles from './AccordionFilter.styles';

const AccordionFilter = ({
  title,
  theme = Theme.light,
  children,
  expanded = false,
}: PropsWithChildren<{ title: string; theme?: ThemeType; expanded?: boolean }>) => {
  const classes = useStyles({});
  const [localExpanded, setLocalExpanded] = useState(expanded);
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  useEffect(() => {
    setLocalExpanded(expanded);
  }, [expanded]);

  return (
    <div className={rootClassName}>
      <MuiAccordion
        className={classes.accordion}
        expanded={localExpanded}
        square
        onChange={(e: ChangeEvent<any>, isExpanded: any) => setLocalExpanded(isExpanded)}
      >
        <MuiAccordionSummary
          className={classes.summary}
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${title}_facets`}
        >
          <MuiTypography variant="h5">{title}</MuiTypography>
        </MuiAccordionSummary>
        <MuiAccordionDetails className={classes.summaryDetails}>{children}</MuiAccordionDetails>
      </MuiAccordion>
    </div>
  );
};

export default memo(AccordionFilter);
